<template>
  <!--Add to the body div id="informText"-->
  <component :is="settings.tag" class="def-inform-text" v-bind="$attrs">
    <teleport to="#informText">
      <Transition name="fade">
        <span
          v-if="isShowText"
          ref="content"
          :class="`${contentClasses}`"
          class="def-inform-text__content"
          :style="contentStyles"
        >
          <slot name="content" />
        </span>
      </Transition>
    </teleport>

    <component
      :is="settings.tag"
      ref="inform"
      class="def-inform-text__inform"
      @mouseenter="isShowText = true"
      @mouseleave="isShowText = false"
    >
      <slot />
    </component>
  </component>
</template>

<script lang="ts" setup>
import { ref, watch, nextTick } from 'vue';

const props = withDefaults(
  defineProps<{
    settings?: {
      positionY?: 'top' | 'bottom';
      tag?: 'div' | 'span';
    };
  }>(),
  {
    settings: () => ({
      positionY: 'top',
      tag: 'span',
    }),
  }
);

const isShowText = ref(false);
const contentClasses = ref('');
const contentStyles = ref({
  top: '',
  left: '',
});
const inform = ref(null);
const content = ref(null);

watch(isShowText, async (newValue) => {
  try {
    await nextTick();
    if (!inform.value || !content.value) return undefined;

    if (newValue) {
      contentClasses.value = '';
      const { left, top, width, height } = inform.value.getBoundingClientRect();
      const { screen } = window;

      // const informRight = screen.width - left - width;
      const informBottom = screen.height - top - height;

      await nextTick();

      // const contentWidth = this.$refs.content.offsetWidth;
      const contentHeight = content.value.offsetHeight;

      contentStyles.value.top = `${top - contentHeight - 20 + window.scrollY}px`;
      contentStyles.value.left = `${left}px`;
      // по вертикали
      if (top < contentHeight || props.settings?.positionY === 'bottom') {
        /** контент с верху страницы * */
        contentStyles.value.top = `${top + window.scrollY + height + 20}px`;
        contentStyles.value.left = `${left - 10}px`;
        contentClasses.value += 'def-inform-text__top ';
      } else if (informBottom < contentHeight) {
        /** контент в низу страницы * */
        contentClasses.value += 'def-inform-text__bottom ';
      }
    }

    return undefined;
  } catch (err) {
    console.error(err);
    return undefined;
  }
});
</script>

<style lang="scss" scoped>
.def-inform-text {
  display: inline-block;
  position: relative;
  &__content {
    position: absolute;
    padding: 8px;
    font-size: rem(14);
    line-height: 115%;
    background: var(--background-beige);
    //bottom: calc(100% + 10px);
    z-index: 10003;
    width: 100vw;
    max-width: 154px;
    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      transform: translateY(100%);
      border: 5px solid transparent;
      border-top-color: var(--background-beige);
      border-left-color: var(--background-beige);
    }
  }
  &__inform {
    display: inline-block;
    cursor: pointer;
  }
  &__top {
    &:after {
      transform: translateY(-100%);
      top: 0;
      bottom: unset;
      border-top-color: transparent;
      border-bottom-color: var(--background-beige);
      border-left-color: transparent;
      border-right-color: var(--background-beige);
    }
  }
  &__left {
    left: 3px;
  }
  &__right {
    right: calc(100% - 20px);
    &:after {
      right: 8px;
      border-left-color: transparent;
      border-right-color: var(--background-beige);
    }
  }
}
</style>
